import * as Redux from 'redux'
import * as UserMenu from './user-menu'

export const reducer = Redux.combineReducers({
  userMenu: UserMenu.reducer,
})



// WEBPACK FOOTER //
// ./src/components/menu/reducer.ts